import { useEffect } from 'react';

import { SportManager, useSportsbookState, useSportState } from '@atlas/core';

//Maybe this code is useless now, this logic should be in core lib
const SportItemDestruction = () => {
  const { id } = useSportsbookState();
  const { categories, id: sportId, initialized } = useSportState();

  useEffect(() => {
    if (!initialized || categories.length) return;

    SportManager.sportsbookBroadcaster.emit(id, {
      payload: {
        id: sportId,
      },
      type: 'SPORTSBOOK_SPORT_REMOVE',
    });
  }, [categories.length, id, initialized, sportId]);
};

export default SportItemDestruction;
